import { ComingSoonPage } from './ComingSoonPage';

export default function EthioPropertyInvest() {
  return (
    <ComingSoonPage
      title="Ethio Property Invest"
      description="Discover curated real estate investment opportunities across Ethiopia."
      canonical="https://www.ethiorealestates.com/ethio-property-invest"
      tagline="Curated investment opportunities in Ethiopia's growing real estate market — launching soon."
    />
  );
}
